import React, { useEffect, useState } from 'react';
import { getWarrantyRequests } from './api';

export default function WarrantyRequestList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      const data = await getWarrantyRequests();
      setRows(data);
    } catch (e) {
      console.error(e);
      alert('Failed to load warranty requests');
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{ load() }, []);

  return (
    <div className="card">
      <h2 style={{marginTop:0}}>درخواست های گارانتی</h2>
      {loading ? <div>Loading...</div> : (
        <table className="table">
          <thead>
            <tr>
              <th>شماره سریال محصول</th>
              <th>تلفن تماس</th>
              <th>مرحله پردازش</th>
              <th>تاریخ درخواست</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td>{r.product_serial_number}</td>
                <td>{r.phone_number}</td>
                <td>{r.process_step}</td>
                <td>{r.request_date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
